<template>
<div class="pageCoinRecharge" id="">  
  <XR-head titleText="金币充值" :rightShow="false" ref="head"></XR-head>
  <div class="login-form" v-if="!loaded">
    <mu-row gutter>
      <mu-col width="100" tablet="100" desktop="33">
        <mu-text-field label="会员账号" helpText="" disabled labelFloat fullWidth v-model="userInfo.user_name" />
      </mu-col>
    </mu-row>
    <mu-row gutter>
      <mu-col width="100" tablet="100" desktop="33">
        <mu-date-picker label="汇款日期" labelFloat fullWidth v-model="rechargeInfo.RechargeTime"/>
      </mu-col>
    </mu-row>
    <mu-row gutter>
      <mu-col width="100" tablet="100" desktop="33">
        <mu-text-field label="汇款户名" helpText="" labelFloat fullWidth v-model="rechargeInfo.RechargeName" />
      </mu-col>
    </mu-row>
    <mu-row gutter>
      <mu-col width="100" tablet="100" desktop="33">
        <mu-text-field label="汇款帐号" helpText="" labelFloat fullWidth v-model="rechargeInfo.RechargeAccount" />
      </mu-col>
    </mu-row>
    <mu-row gutter>
      <mu-col width="100" tablet="100" desktop="33">
        <mu-text-field label="汇款银行" helpText="" labelFloat fullWidth v-model="rechargeInfo.BankSite" />
      </mu-col>
    </mu-row>
    <mu-row gutter>
      <mu-col width="100" tablet="100" desktop="33">
        <mu-text-field label="汇款金额" type="number" helpText="" labelFloat fullWidth v-model="rechargeInfo.RechargeAmt" />
      </mu-col>
    </mu-row>
    <mu-row gutter>
      <mu-col width="100" tablet="100" desktop="33">
        <mu-text-field label="联系方式" helpText="" labelFloat fullWidth v-model="rechargeInfo.Phone" />
      </mu-col>
    </mu-row>
    <mu-row gutter>
      <mu-col width="100" tablet="100" desktop="33">
        <mu-text-field label="收款户名" :value="siteInfo.CompanyBankUserName" disabled labelFloat fullWidth />
      </mu-col>
    </mu-row>
    <mu-row gutter>
      <mu-col width="100" tablet="100" desktop="33">
        <mu-text-field label="开户行" :value="siteInfo.CompanyBankName" disabled helpText="" labelFloat fullWidth />
      </mu-col>
    </mu-row>
    <mu-row gutter>
      <mu-col width="100" tablet="100" desktop="33">
        <mu-text-field label="收款账户" :value="siteInfo.CompanyBankNo" disabled labelFloat fullWidth />
      </mu-col>
    </mu-row>
    <mu-row gutter>
      <mu-col width="100" tablet="100" desktop="33">
        <mu-text-field label="备注说明" multiLine :rows="3" :rowsMax="6" labelFloat fullWidth v-model="rechargeInfo.Remark"/>
      </mu-col>
    </mu-row>
    <mu-row gutter>
      <mu-col width="100" tablet="50" desktop="33" class="login-div">
        <mu-raised-button label="提 交" class="demo-raised-button" primary fullWidth @click="submit()" />
      </mu-col>
    </mu-row>
  </div>
  <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>
</div>
</template>
<script>
import {ErrorCode} from '../../util/errorcode'
export default {
  data () {
    return {
      loaded: true,
      rechargeInfo:{},
      siteInfo:{},
      userInfo:{}
    }
  },
  mounted:function(){
    this.$refs.XRtoast.load()
    this.getSiteInfo()
    this.getUserInfo()
  },
  methods: {
    getSiteInfo: function () {      
      const ths = this;
      this.$post('/Shop/SiteConfigServer/GetSiteConfig')
        .then(function (res) {
          if(res.IsSuccess){
            ths.loaded = false;
            ths.siteInfo = res.Data
            ths.$refs.XRtoast.hide()
          }         
        })
        .catch(function (err) {
          console.log(err)
        })    
    },    
    getUserInfo(){
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.loaded =false
          ths.userInfo = res.Data
          ths.$refs.XRtoast.hide()
        }
      });      
    },
    submit: function(){
      const ths = this;
	  if (!this.rechargeInfo.RechargeName){
		ths.$refs.XRtoast.failed("请输入汇款户名",true);
		return;
	  }
	  if (this.rechargeInfo.RechargeName.length > 20){
		ths.$refs.XRtoast.failed("汇款户名不能超过20",true);
		return;
	  }
	  if (!this.rechargeInfo.RechargeAccount){
		ths.$refs.XRtoast.failed("请输入汇款账号",true);
		return;
	  }
	  if (this.rechargeInfo.RechargeAccount.length > 20){
		ths.$refs.XRtoast.failed("汇款账号不能超过20",true);
		return;
	  }
	  if (!this.rechargeInfo.BankSite){
		ths.$refs.XRtoast.failed("请输入汇款银行",true);
		return;
	  }
	  if (this.rechargeInfo.BankSite.length > 20){
		ths.$refs.XRtoast.failed("汇款银行不能超过20",true);
		return;
	  }
	  if (!this.rechargeInfo.RechargeAmt){
		ths.$refs.XRtoast.failed("请输入汇款金额",true);
		return;
	  }
      this.$post('/Shop/UserServer/CoinRecharge', JSON.stringify(this.rechargeInfo))
        .then(function (res) {
          if(!res.IsSuccess){
            if(res.TypeId == ErrorCode.SessionMissing){
              ths.$router.push("/Login")
            }
            ths.$refs.XRtoast.failed(res.Msg,true)
          }  
          else{
            ths.$refs.XRtoast.success(res.Msg,true) 
          }   
             
        })
        .catch(function (err) {
          console.log(err)
        })    
    },
    goBack(){
      this.$router.goBack()
    }
  }
}

</script>
<style>
#app .pageCoinRecharge{
  background: white;
  bottom: unset;
}
.pageCoinRecharge .login-form {
  padding: 10px 20px 20px 10px;
}
.pageCoinRecharge .login-div {
  padding: 40px 0px 0 20px;
}
.pageCoinRecharge .demo-raised-button {
  height: 50px;
}
.pageCoinRecharge .div2 {
  padding: 20px 0 0 0;
}
.pageCoinRecharge .demo-flat-button.right {
  float: right;
}
.pageCoinRecharge .div3 {
  text-align: center;
  position: absolute;
  bottom: 40px;
  left: 0;
}
.pageCoinRecharge .pageCoinRecharge .notice{
  font-size: 12px;
}
.pageCoinRecharge .sms-button{
  margin-top: 28px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/coinRecharge.vue